<template>
  <div style="">
    <el-row>
      <span >
        <el-button type="text" @click="add">Add New <i class="fas fa-plus-square"/></el-button>
        <el-input v-debounce="getAll" :debounce-events="'keydown'" v-model="term" size="small" type="text" placeholder="search" style="width: 40em" ><i slot="suffix" class="el-input__icon el-icon-search"/></el-input>
      </span>
    </el-row>
    <el-row>
      <el-col>
        <el-table
          ref="multipleTable"
          :data="deduction"
          border
          style="width: 100%">
          <el-table-column
            label="Default"
            width="100"
          >
            <template slot-scope="scope">
              <el-checkbox :key="scope.row.default" :checked="scope.row.default===1" @change="changeStatus(scope.row.id, $event)" />
            </template>
          </el-table-column>
          <el-table-column prop="code" label="Code" />
          <el-table-column prop="desc" label="Description" width="300"/>
          <el-table-column prop="agency.name" label="Address" width="300"/>
          <el-table-column prop="incharge.acronym" label="Office" />
          <el-table-column prop="type.name" label="Deduction type" />
          <el-table-column label="Action">
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click="edit(scope.row)" ><i class="fas fa-file-invoice"/></el-button>
              <el-button v-if="scope.row.id === 36 || scope.row.id === 26 || scope.row.id === 23 || scope.row.id === 34" type="warning" size="mini" @click="$router.push({ name: 'Deduction value', params: { id: scope.row.id }})" >Default value</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;">
          <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
        </div>
      </el-col>
    </el-row>
    <el-dialog v-if="editable" :visible.sync="editable" :title="title" width="50%" center >
      <el-form ref="form" :model="form" label-position="top">
        <el-form-item label="Code" prop="code">
          <el-input
            v-model="form.code"
            placeholder="Please input"
            clearable />
        </el-form-item>
        <el-form-item label="Description" prop="description">
          <el-input
            v-model="form.desc"
            placeholder="Please input"
            clearable />
        </el-form-item>
        <el-form-item label="Agency" prop="agency">
          <select-agency :agen="agency" :key="sel" @setAgency="form.agency_id = $event"/>
        </el-form-item>
        <el-form-item label="Department" prop="department">
          <select-department :dept="department" @setDepartment="form.incharge = $event"/>
        </el-form-item>
        <el-form-item label="Deduction type" prop="type">
          <el-select v-model="form.deduction_type" placeholder="Select">
            <el-option
              v-for="item in types"
              :key="item.id"
              :label="item.name"
              :value="item.id"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editable = false">Cancel</el-button>
        <el-button type="primary" @click="save()">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { Deduction } from '@/api/payroll/deduction'
import { Notification } from 'element-ui'
import SelectAgency from '../../../views/layout/components/SelectAgency'
import SelectDepartment from '../../../views/layout/components/SelectDepartment'
export default {
  name: 'Deduction',
  components: {
    SelectAgency,
    SelectDepartment
  },
  data() {
    return {
      meta: {
        page: 1
      },
      form: {
        id: null,
        code: '',
        desc: '',
        agency_id: '',
        incharge: '',
        deduction_type: 1
      },
      types: [],
      term: '',
      department: '',
      deduction: [],
      agency: {},
      editable: false,
      selected: null,
      agency_id: null,
      sel: 0

    }
  },
  watch: {
    agency: function() {
      this.sel++
    }
  },
  created() {
    this.getAll()
    this.getType()
  },
  methods: {
    getAll() {
      this.editable = false
      this.selected = null
      Deduction({ term: this.term, page: this.meta.page }).then(res => {
        this.deduction = res.data.deduction
        this.meta = res.data.meta
      }).catch(error => {
        console.log(error)
      })
    },
    getType() {
      Deduction({}, 'get', 'type').then(res => {
        this.types = res.data.deduction_type
      }).catch(error => {
        console.log(error)
      })
    },
    changeStatus(id, row) {
      console.log(id)
    },
    add() {
      this.form = {
        id: null,
        code: '',
        desc: '',
        agency_id: '',
        deduction_type: 1
      }
      this.title = 'New Deduction'
      this.editable = true
    },
    save() {
      var action = this.form.id ? 'patch' : 'post'
      Deduction(this.form, action).then(res => {
        Notification.success({
          title: 'Success',
          message: (action === 'post') ? 'Deduction has been saved successfully' : 'Deduction Updated successfully',
          duration: 4 * 1000
        })
        this.getAll()
      }).catch(error => {
        console.log(error)
      })
    },
    edit(index) {
      console.log(index)
      this.department = index.incharge
      this.editable = true
      this.title = 'Edit Deduction'
      this.agency = index.agency
      this.form = {
        id: index.id,
        code: index.code,
        desc: index.desc,
        agency_id: index.agency_id,
        incharge: (index.incharge) ? index.incharge.id : null,
        deduction_type: (index.type) ? index.type.id : null
      }
    }
  }
}

</script>
